import { render, staticRenderFns } from "./KeenUiIconButton.vue?vue&type=template&id=71ae341c&"
import script from "./KeenUiIconButton.vue?vue&type=script&lang=js&"
export * from "./KeenUiIconButton.vue?vue&type=script&lang=js&"
import style0 from "./KeenUiIconButton.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports